import styled from 'styled-components';

import AnimatedRow from '@kiosk/common/components/Forms/AnimatedRow';

export const StyledAnimatedRow = styled(AnimatedRow)`
  width: 100%;
`;
